// Angular
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// Mindkind App
import { HEADER_STATES } from 'src/app/shared/header/header.helper';
import { APP_COLORS } from 'src/global-styles';
// SNE - Oral Communication
import { SNE_INPUT_TYPES } from 'src/app/types/sne';
import { SneOralCommunicationBase } from '../sne-oral-communcation.base';
import { SneAnswerService } from 'src/app/services/sne-answer.service';
import { SneVideoComponent } from '../../components/sne-video/sne-video.component';

@Component({
  selector: 'ets-madlibs-full',
  templateUrl: './madlibs-full.component.html',
  styleUrls: ['./madlibs-full.component.scss']
})
export class MadlibsFullComponent extends SneOralCommunicationBase implements OnInit {
  @ViewChild(SneVideoComponent) videoComp!:SneVideoComponent;

  headerState: HEADER_STATES = HEADER_STATES.BACK;
  headerQuestion: string = '';
  showModal = false;
  responseLength = 0;

  APP_COLORS = APP_COLORS;
  SNE_INPUT_TYPES = SNE_INPUT_TYPES;

  constructor(route: ActivatedRoute, router: Router, sneAnswerService: SneAnswerService) {
    super(route, router, sneAnswerService);
  }

  ngOnInit(): void {
    this.processParams();
  }

  toggleModal() {
    this.showModal=!this.showModal;
  }

  handleOptionsSelected(response: any[]){
    this.responseLength = (response.filter(x => x===true)).length;
    console.log(response);
    console.log(this.responseLength);
  }

  handleUserResponse(response: any[]) {

    let idx: number = response[0];
    let option: string = response[1];
    let letter: string = response[2];

    this.madlibsResponse[idx] = letter;
    // this.responseLength = Object.keys(this.madlibsResponse).length;
  }

  closeModal(){
    if(this.videoComp){
      this.videoComp.onModalClose();
    }
    this.closeInstructionModal();
  }
}

